
import { useState } from "react";
// react-router-dom components
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// layout components
import LogoutPageLayout from "layouts/logoutpage/LogoutPageLayout.js";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Config from "config.js";
import { Backdrop } from "@mui/material";

function Login(props) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const BASE = Config.BASE;

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const res = await axios({
      url: BASE + "api/login",
      method: "POST",
      data: { email: data.email, password: data.password },
      headers: {
        authorization: "no-token",
        function: Config.FUNCTION_KEY
      }
    });
    setIsLoading(false);
    if (res.status == 200 && res.data.status == 1) {
      localStorage.setItem('token', res.data.data.token);
      localStorage.setItem('id', JSON.stringify(res.data.data.id));
      localStorage.setItem('type', res.data.data.type);
      localStorage.setItem('resetPassword', res.data.data.resetPassword)
      if (res.data.data.type == 2)
        localStorage.setItem('privileges', JSON.stringify(res.data.data.privileges))
      window.location.href = '/dashboard';    //window.location is used instead of navigate() as menu is initialised before login and menu items need to be reset based on logged in user
    }
    else if (res.status == 200 && res.data.status == 0) {
      toast.error(t(res.data.message)), {
        position: toast.POSITION.TOP_CENTER
      }
    }
    else if (res.status != 200) {
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('type');
      localStorage.removeItem('privileges');
      toast.error(t(res.data.message)), {
        position: toast.POSITION.TOP_CENTER
      }
    }
  };

  return (
    <LogoutPageLayout image={bgImage} >
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>{t('log in')}</MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput key={'email'} type="email" name="email" label="Email" {...register("email", { required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ })} fullWidth />
              {errors.email && errors.email.type === "required" && (
                <p className="errorMsg">{t('emailRequired')}</p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="errorMsg">{t('emailNotValid')}</p>
              )}
              {errors.email && (
                <p className="errorMsg">{errors.email.message}</p>
              )}
            </MDBox>
            <MDBox mb={2}>
              <MDInput key="password" type="password" name="password" label="Password" {...register("password", { required: true })} fullWidth />
              {errors.password && errors.password.type === "required" && (
                <p className="errorMsg">{t('passwordRequired')}</p>
              )}
              {errors.password && (
                <p className="errorMsg">{errors.password.message}</p>
              )}
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton key="submit" type="submit" variant="gradient" color="info" disableRipple fullWidth>sign in</MDButton>
            </MDBox>
          </MDBox>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Forgot Password? {" "}
              <MDTypography
                component={Link}
                to="/admin/forgotpassword"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                {t('click here')}
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
      <ToastContainer position="top-center" />
    </LogoutPageLayout>
  );
}

export default Login;
